import React, { useMemo, useState } from 'react'
import { SettingItem } from './Common/SettingItem'
import { registerForMicrosoftDynamicsPushNotification } from '@core/Utils/hooks/useRegisterForMicrosoftDynamicsPushNotification'

export function DynamicsPushTestSettings() {
  const [status, setStatus] = useState('')
  const guid = useMemo(() => {
    if (!status.startsWith('Error')) {
      const t = status.split(' ')
      return t[t.length - 1]
    } else {
      return undefined
    }
  }, [status])

  return (
    <SettingItem
      label='[test-only] Customer Insights Push Notifications'
      description='Tap button to register for push. Contact with account number must exist in CI-J'
      bottomComponent={
        status ? (
          status?.startsWith('Error') ? (
            <b style={{ color: 'red' }}>{status}</b>
          ) : (
            <>
              {status} (<TapToCopyButton label='tap to copy' textToCopy={guid ?? ''} />)
            </>
          )
        ) : null
      }
      rightComponent={
        <RegistrationButton
          onSuccess={guid => setStatus(`Registration triggered: ${guid}`)}
          onFailure={e => setStatus(`Error: ${e.message}`)}
        />
      }
    ></SettingItem>
  )
}

function TapToCopyButton({ label, textToCopy }: { label: string; textToCopy: string }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // .. no-op
    }
  }

  return <span onClick={handleCopy}>{copied ? 'copied...' : label}</span>
}

function RegistrationButton({
  onSuccess,
  onFailure,
}: {
  onSuccess?: (statusGuid: string) => void
  onFailure?: (e: Error) => void
}) {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <button
      type='button'
      disabled={isLoading}
      onClick={async () => {
        setIsLoading(true)
        try {
          const response = await registerForMicrosoftDynamicsPushNotification()
          if (response) {
            onSuccess?.(response.RegistrationRequestId)
          }
        } catch (e) {
          onFailure?.(e as Error)
        } finally {
          setIsLoading(false)
        }
      }}
    >
      {!isLoading ? 'register' : 'loading...'}
    </button>
  )
}
